import IOnlineApplicationMerchant from '@sunbit-dev/common/models/IOnlineApplicationMerchant';
import { DocumentTypesTypes } from '@sunbit-dev/common/enums/DocumentTypes';
import * as qs from 'qs';
import { urls } from '~/models/urls';

export const getSubUrlName = (location: { pathname: string }): string => {
  const splitPathName: string[] = location.pathname.split('/');
  return splitPathName[1] || '';
};

export const getDepartmentIdHeader = (searchParam: string): string => {
  const departmentIdFromLink = searchParam.split('departmentId=')[1];
  if (departmentIdFromLink) {
    return `departmentId=${departmentIdFromLink}`;
  }
  return '';
};

export function documentUrls(onlineApplicationMerchant: IOnlineApplicationMerchant) {
  const retailerId = onlineApplicationMerchant.merchantId;
  const baseUrl = `${urls.document}?retailerId=${retailerId}&documentType=`;

  return {
    arbitrationProvisionUrl: baseUrl + DocumentTypesTypes.PurchaseAgreementArbitrationAgreement,
    ratesAndTermsUrl: urls.root + DocumentTypesTypes.RatesAndTerms,
    privacyPolicyUrl: baseUrl + DocumentTypesTypes.PurchaseAgreementPrivacyPolicy,
    termsOfUseUrl: baseUrl + DocumentTypesTypes.SunbitOnlineServicesTermsOfUse,
    termsAndConditionsUrl: baseUrl + DocumentTypesTypes.TermsAndConditions,
    electronicConsentUrl: baseUrl + DocumentTypesTypes.PurchaseAgreementElectronicConsent,
    creditReportAuthorizationUrl: baseUrl + DocumentTypesTypes.PurchaseAgreementAgreementCpa,
    mxUserAgreement: baseUrl + DocumentTypesTypes.MxUserAgreement,
  };
}
